<template>
    <div>
        <v-dialog
            v-model="showDialogEstimatedBudget"
            transition="dialog-top-transition"
            persistent
            width="500"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    Update Estimated Budget
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>Estimated Budget</label>
                            <v-text-field
                                v-model="estimatedBudget" 
                                v-formatMoney="moneyFormat"
                                :rules=[validations.required]
                                single-line
                                outlined
                                dense
                            >
                            </v-text-field>

                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonCancel v-btn-large"
							outlined
							@click="cancel"
						>
							Cancel
						</v-btn>

						<v-btn
							class="mx-2 v-btn-large"
							outlined
                            @click="confirm"
						>
							Confirm
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>
	</div>
</template>

<script>

    import Helpers from '@/utilities/Helpers';
    import { required } from "@/utilities/Rules";
    import { formaterDecimalBRServer } from '@/utilities/Utils';

	export default {

        mixins: [Helpers],

        props: {
			
            id: {
                type: Number,
                default: 0
            },

            setEstimatedBudget: {
                default: null
            },

			showDialogEstimatedBudget: {
				default: false
			},
		},

        watch: {
            async "setEstimatedBudget"() {
				if (this.setEstimatedBudget != null && this.setEstimatedBudget != undefined) {
                    this.estimatedBudget = this.setEstimatedBudget;
                }
            },
        },
		
        data: () => ({
			
            estimatedBudget: 0,

            moneyFormat: {
                prefix: '$ ',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 2,
            },

            validations: {
                required
            },
		}),

        methods: {

            cancel() {
                this.$emit('update:showDialogEstimatedBudget', false);
            },

            async confirm() {

                const estimatedBudget = formaterDecimalBRServer(this.estimatedBudget);

                if (this.estimatedBudget <= 0) {
                    this.showToast("error", "Error!", "Please enter a value for the estimated budget!");
                }
                else {
                    const request = {
                        idService: this.id,
                        estimatedBudgetRequest: {
                            estimatedBudget
                        }
                    }

                    const result = await this.$store.dispatch("serviceModule/UpdateEstimatedBudget", request);

                    if (result.success) {
                        this.showToast("success", "Success!", "Estimated budget updated successfully!");

                        this.$emit('methodConfirmToCall');
                    }
                    this.cancel();
                }
            }
        }
    };
</script>